__turbopack_context__.v({
  "icon": "icon-module__Ko1fIq__icon",
  "iconLg": "icon-module__Ko1fIq__iconLg",
  "iconMd": "icon-module__Ko1fIq__iconMd",
  "iconSm": "icon-module__Ko1fIq__iconSm",
});
